import React from 'react';
import { motion } from 'framer-motion';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';

const stats = [
  { value: '5,000+', label: 'Messages Handled Daily' },
  { value: '95%', label: 'Resolution Rate' },
  { value: '<2s', label: 'Avg. Response Time' },
  { value: '500+', label: 'Businesses Trust Us' },
];

export const StatsBar = () => {
  const [ref, isVisible] = useScrollAnimation(0.2);

  return (
    <section ref={ref} className="py-16 border-t border-b border-border/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, i) => (
            <motion.div
              key={stat.label}
              initial={{ opacity: 0, y: 20 }}
              animate={isVisible ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="text-center"
            >
              <p className="font-heading text-3xl lg:text-4xl font-bold gradient-text-primary mb-1">
                {stat.value}
              </p>
              <p className="text-sm text-muted-foreground font-body">{stat.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
